import { Navigate } from "react-router-dom";
import { getSessionUserInformation } from "app/utils/utility.service";

/**
 * ProtectedRoute Component
 * 
 * Security: Ensures that only authenticated users can access protected routes.
 * Redirects unauthenticated users to the login page.
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The component to render if authenticated
 * @returns {React.ReactNode} - Either the protected component or redirect to login
 */
const ProtectedRoute = ({ children }) => {
  const userInfo = getSessionUserInformation();

  // Check if user is authenticated (has valid token)
  if (!userInfo || !userInfo.token) {
    // Redirect to login page if not authenticated
    return <Navigate to="/session/signin/step1" replace />;
  }

  // User is authenticated, render the protected component
  return children;
};

export default ProtectedRoute;
